import Marty from "marty";
import catchError from "../utils/functions/catchApiError";

let userAPI = Marty.createStateSource({
    type: "http",
    cancelOrder(body){
        return this.post({
            url: "/cancel",
            body
        }).then(catchError("Error cancelling order"));
    }
});

export default userAPI;



/** WEBPACK FOOTER **
 ** ./app/sources/userAPI.js
 **/